/* eslint-disable react/require-default-props */

import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {Shared} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import KeyboardFocusable from '../ExtKeyboard/KeyboardFocusable';

import RadioButton from './RadioButton';
import {styles} from './RadioButton.style';

type RadioButtonOption = {
  text: string;
  selected: boolean;
  onPress: () => void;
  testID?: string;
  subText?: string;
  accessibilityLabel?: string;
  accessibilityHint?: string;
};

interface RadioButtonGroupProps {
  title: string;
  options: RadioButtonOption[];
  isBold?: boolean;
  titleStyle?: {};
  subTextStyle?: {};
  useAccessibleTitleWrapper?: boolean;
  testID?: string;
  allowFontScaling?: boolean;
  maxFontSizeMultiplier?: number;
}

const DEFAULT_MAX_FONT_SIZE_MULTIPLIER = 2;

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  title = '',
  options = [],
  isBold = false,
  titleStyle = null,
  subTextStyle = {},
  useAccessibleTitleWrapper = false,
  testID,
  allowFontScaling = true,
  maxFontSizeMultiplier = DEFAULT_MAX_FONT_SIZE_MULTIPLIER,
}) => {
  const textScalingProps = {
    allowFontScaling,
    maxFontSizeMultiplier,
  };

  return (
    <View
      testID={testID}
      accessible={false}
      accessibilityRole={useAccessibleTitleWrapper ? undefined : 'radiogroup'}
      accessibilityLabel={useAccessibleTitleWrapper ? undefined : title}>
      {useAccessibleTitleWrapper ? (
        <KeyboardFocusable
          accessible
          focusable
          accessibilityLabel={title}
          accessibilityRole="header"
          testID="radio-button-group-title">
          <Text
            {...textScalingProps}
            accessible
            style={[styles.filterTypeText, titleStyle]}
            isBold
            testID="radio-button-group-title-text">
            {title}
          </Text>
        </KeyboardFocusable>
      ) : (
        <Text
          {...textScalingProps}
          testID={testID}
          style={[styles.filterTypeText, titleStyle]}
          {...testProperties(Shared.radioButtonGroupTitle)}
          accessible
          accessibilityRole="header"
          isBold>
          {title}
        </Text>
      )}

      {options.map((option, index) => (
        <View key={option.testID || index}>
          <RadioButton {...option} isBold={isBold} {...textScalingProps} />

          {option.subText ? (
            <View
              accessible
              testID={`${option.testID}-subtext-wrapper`}
              style={styles.subTextWrapper}>
              <Text
                {...textScalingProps}
                style={subTextStyle}
                accessible
                accessibilityLabel={option.subText}
                testID={`${option.testID}-subtext`}>
                {option.subText}
              </Text>
            </View>
          ) : null}
        </View>
      ))}
    </View>
  );
};

export default RadioButtonGroup;
